/**
 * Calendar and clock arithmetic of the picker. Kept local rather than taken from
 * `@shared-util-types`, which itself imports `@shared-ui-kit`.
 */

export const MONTHS_PER_YEAR = 12;
export const MAX_DAY_OF_MONTH = 31;
export const HOURS_PER_DAY = 24;
export const HOURS_PER_HALF_DAY = 12;
export const MINUTES_PER_HOUR = 60;
export const LAST_HOUR_OF_DAY = HOURS_PER_DAY - 1;
export const LAST_MINUTE_OF_HOUR = MINUTES_PER_HOUR - 1;
export const LAST_SECOND_OF_MINUTE = 59;

/** A year typed in full: `2026`. */
export const FULL_YEAR_DIGITS = 4;
export const YEARS_PER_CENTURY = 100;
/** Short years belong to this century: `26` -> `2026`. */
export const SHORT_YEAR_CENTURY_START = 2000;

/** Year, month and day. */
export const DATE_FIELD_COUNT = 3;

export const DECIMAL_BASE = 10;
